var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260.989,
    height: 189.532,
    viewBox: "0 0 260.989 189.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #cdd7e1;\n      }\n\n      .cls-2 {\n        fill: #083041;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #aa5858;\n      }\n\n      .cls-5 {\n        fill: #4d8af0;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8 {\n        opacity: 0.5;\n      }\n\n      .cls-6 {\n        fill: #f55f44;\n      }\n\n      .cls-7, .cls-9 {\n        fill: #47e6b1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8338",
    "data-name": "Grupo 8338",
    transform: "translate(-553 -266.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8335",
    "data-name": "Grupo 8335",
    transform: "translate(554.512 322.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5315",
    "data-name": "Trazado 5315",
    className: "cls-1",
    d: "M111.776,417.207l11.15-17.694-11.155,19.621-.006,2.016q-1.193-.014-2.362-.091l.909-25.9-.012-.2.02-.038.087-2.447L98.75,373.082l11.67,17.56.035.518.687-19.568-10.022-20.064,10.1,16.626.47-40.559,0-.135,0,.133.229,31.978,9.577-12.795-9.585,15.549-.044,17.514,8.886-16.916-8.891,19.49-.025,9.739L124.747,368.6l-12.917,26.95Z",
    transform: "translate(-98.75 -292.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6058",
    "data-name": "Rect\\xE1ngulo 6058",
    className: "cls-2",
    width: 3.135,
    height: 22.255,
    transform: "translate(166.389 50.153)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6059",
    "data-name": "Rect\\xE1ngulo 6059",
    className: "cls-2",
    width: 3.135,
    height: 125.185,
    transform: "translate(52.357 5.695) rotate(-67.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5316",
    "data-name": "Trazado 5316",
    className: "cls-1",
    d: "M358.6,668.886c-4.855,8.111-259.732,7.43-259.346,0C104.106,660.775,358.983,661.456,358.6,668.886Z",
    transform: "translate(-99.121 -541.104)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6060",
    "data-name": "Rect\\xE1ngulo 6060",
    className: "cls-2",
    width: 27.271,
    height: 10.657,
    transform: "translate(200.242 94.977)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6061",
    "data-name": "Rect\\xE1ngulo 6061",
    className: "cls-2",
    width: 134.472,
    height: 11.911,
    transform: "translate(90.533 104.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5317",
    "data-name": "Trazado 5317",
    className: "cls-1",
    d: "M691.486,310.05H659.2V269.458h24.136l8.15,20.473Z",
    transform: "translate(-488.58 -199.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6062",
    "data-name": "Rect\\xE1ngulo 6062",
    className: "cls-3",
    width: 13.792,
    height: 13.792,
    transform: "translate(175.636 72.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5318",
    "data-name": "Trazado 5318",
    className: "cls-3",
    d: "M746.695,293.544h-8.777V279.752h3.762Z",
    transform: "translate(-546.923 -207.344)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6063",
    "data-name": "Rect\\xE1ngulo 6063",
    className: "cls-2",
    width: 3.135,
    height: 5.956,
    transform: "translate(176.263 93.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5319",
    "data-name": "Trazado 5319",
    className: "cls-2",
    d: "M748.212,313.661h.157a2.978,2.978,0,0,1,2.978,2.978h0a2.978,2.978,0,0,1-2.978,2.978h-.157Z",
    transform: "translate(-554.553 -232.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5320",
    "data-name": "Trazado 5320",
    className: "cls-2",
    d: "M297.7,403.278h.157a2.978,2.978,0,0,1,2.978,2.978h0a2.978,2.978,0,0,1-2.978,2.978H297.7Z",
    transform: "translate(-220.649 -298.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5321",
    "data-name": "Trazado 5321",
    className: "cls-1",
    d: "M886.7,549a15.509,15.509,0,0,1,12.054,6h6.126l-5.956-16.59-27.741-5.471.784,22.061h2.678A15.509,15.509,0,0,1,886.7,549Z",
    transform: "translate(-671.254 -444.669)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_832",
    "data-name": "Elipse 832",
    className: "cls-2",
    cx: 13.635,
    cy: 13.635,
    r: 13.635,
    transform: "translate(202.123 100.619)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_833",
    "data-name": "Elipse 833",
    className: "cls-1",
    cx: 7.176,
    cy: 7.176,
    r: 7.176,
    transform: "translate(208.581 107.078)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_834",
    "data-name": "Elipse 834",
    className: "cls-2",
    cx: 11.911,
    cy: 11.911,
    r: 11.911,
    transform: "translate(80.659 103.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_835",
    "data-name": "Elipse 835",
    className: "cls-1",
    cx: 6.269,
    cy: 6.269,
    r: 6.269,
    transform: "translate(86.301 109.552)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6064",
    "data-name": "Rect\\xE1ngulo 6064",
    className: "cls-2",
    width: 6.583,
    height: 47.488,
    transform: "translate(164.978 64.101)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6065",
    "data-name": "Rect\\xE1ngulo 6065",
    className: "cls-2",
    width: 94.663,
    height: 2.821,
    transform: "translate(76.898 102.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6066",
    "data-name": "Rect\\xE1ngulo 6066",
    className: "cls-2",
    width: 106.989,
    height: 2.821,
    transform: "translate(26.239 113.324) rotate(-15.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6067",
    "data-name": "Rect\\xE1ngulo 6067",
    className: "cls-2",
    width: 2.194,
    height: 18.34,
    transform: "translate(120.659 89.958) rotate(-36.311)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6068",
    "data-name": "Rect\\xE1ngulo 6068",
    className: "cls-2",
    width: 3.135,
    height: 1.254,
    transform: "translate(192.405 86.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5322",
    "data-name": "Trazado 5322",
    className: "cls-2",
    d: "M629.174,527.778H588.111a.313.313,0,0,1-.089-.614l40.122-11.911a.313.313,0,0,1,.4.276l.94,11.911a.313.313,0,0,1-.313.338Zm-38.905-.627h38.566l-.883-11.187Z",
    transform: "translate(-461.218 -431.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5323",
    "data-name": "Trazado 5323",
    className: "cls-2",
    d: "M291.384,391.537h0l-9-.085a.313.313,0,0,1-.309-.349l4.675-40.8a.314.314,0,0,1,.311-.278h0a.314.314,0,0,1,.31.281l4.323,40.88a.313.313,0,0,1-.312.346Zm-8.647-.708,8.3.078-3.987-37.7Z",
    transform: "translate(-234.622 -309.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5324",
    "data-name": "Trazado 5324",
    className: "cls-2",
    d: "M0,0H.157A2.978,2.978,0,0,1,3.135,2.978h0A2.978,2.978,0,0,1,.157,5.956H0Z",
    transform: "matrix(-0.935, 0.354, -0.354, -0.935, 229.717, 99.558)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6069",
    "data-name": "Rect\\xE1ngulo 6069",
    className: "cls-2",
    width: 9.08,
    height: 1.441,
    transform: "translate(30.308 103.834) rotate(-15.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5325",
    "data-name": "Trazado 5325",
    className: "cls-4",
    d: "M277.281,441.983l-1.688.921-68.562,19.191-1.018-1.264a15.056,15.056,0,0,1-3.256-7.543c-.259-2.067-.07-4.245,1.372-5.571L201.51,426.6l37.919-10.665,17.985,7.739s6.889-2.059,11.959,1.574a11.412,11.412,0,0,1,3.99,5.411l.829,2.395Z",
    transform: "translate(-174.913 -357.944)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_836",
    "data-name": "Elipse 836",
    className: "cls-2",
    cx: 8.792,
    cy: 8.792,
    r: 8.792,
    transform: "translate(78.42 79.115)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_837",
    "data-name": "Elipse 837",
    className: "cls-1",
    cx: 4.627,
    cy: 4.627,
    r: 4.627,
    transform: "translate(82.585 83.279)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_838",
    "data-name": "Elipse 838",
    className: "cls-2",
    cx: 8.792,
    cy: 8.792,
    r: 8.792,
    transform: "translate(36.645 90.808)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_839",
    "data-name": "Elipse 839",
    className: "cls-1",
    cx: 4.627,
    cy: 4.627,
    r: 4.627,
    transform: "translate(40.809 94.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5326",
    "data-name": "Trazado 5326",
    className: "cls-3",
    d: "M210.264,239.333l-27.2,7.614-2.292-8.189,17.349-4.856Z",
    transform: "translate(-133.981 -173.362)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6070",
    "data-name": "Rect\\xE1ngulo 6070",
    className: "cls-3",
    width: 11.242,
    height: 8.503,
    transform: "translate(32.632 69.36) rotate(-15.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6071",
    "data-name": "Rect\\xE1ngulo 6071",
    className: "cls-2",
    width: 1.441,
    height: 2.738,
    transform: "translate(50.789 79.693) rotate(-15.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6072",
    "data-name": "Rect\\xE1ngulo 6072",
    className: "cls-2",
    width: 1.441,
    height: 2.738,
    transform: "translate(74.028 69.147) rotate(74.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5327",
    "data-name": "Trazado 5327",
    className: "cls-2",
    d: "M0,0H.159A3.012,3.012,0,0,1,3.171,3.012h0A3.012,3.012,0,0,1,.159,6.024H0Z",
    transform: "translate(70.91 64.423) rotate(-15.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5328",
    "data-name": "Trazado 5328",
    className: "cls-2",
    d: "M464.03,459.718a4.656,4.656,0,0,1-4.819-7.806,11.412,11.412,0,0,1,3.99,5.411Z",
    transform: "translate(-364.751 -384.611)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6073",
    "data-name": "Rect\\xE1ngulo 6073",
    className: "cls-2",
    width: 3.135,
    height: 45.764,
    transform: "translate(50.724 2.821)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_840",
    "data-name": "Elipse 840",
    className: "cls-2",
    cx: 4.388,
    cy: 4.388,
    r: 4.388,
    transform: "translate(47.903 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_841",
    "data-name": "Elipse 841",
    className: "cls-2",
    cx: 4.388,
    cy: 4.388,
    r: 4.388,
    transform: "translate(163.568 46.391)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8337",
    "data-name": "Grupo 8337",
    transform: "translate(-37.455 -32.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8331",
    "data-name": "Grupo 8331",
    transform: "translate(590.45 287.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5294",
    "data-name": "Trazado 5294",
    className: "cls-5",
    d: "M326.542,109.054a.968.968,0,0,1-.54-1.17.467.467,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.465.465,0,0,0-.054.1.968.968,0,0,1-1.17.54.466.466,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.465.465,0,0,0,.1.054.968.968,0,0,1,.54,1.17.464.464,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.466.466,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.465.465,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.465.465,0,0,0,326.542,109.054Z",
    transform: "translate(-282.979 -96.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5295",
    "data-name": "Trazado 5295",
    className: "cls-5",
    d: "M180.542,434.054a.968.968,0,0,1-.54-1.17.466.466,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.466.466,0,0,0-.054.1.968.968,0,0,1-1.17.54.467.467,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.466.466,0,0,0,.1.054.968.968,0,0,1,.54,1.17.466.466,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.465.465,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.465.465,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.465.465,0,0,0,180.542,434.054Z",
    transform: "translate(-175.456 -335.765)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_824",
    "data-name": "Elipse 824",
    className: "cls-6",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(195.655 65.358)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_825",
    "data-name": "Elipse 825",
    className: "cls-6",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(30.415 178.416)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_826",
    "data-name": "Elipse 826",
    className: "cls-6",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(222.536 126.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5296",
    "data-name": "Trazado 5296",
    className: "cls-5",
    d: "M865.543,138.054a.968.968,0,0,1-.54-1.17.467.467,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.462.462,0,0,0-.054.1.968.968,0,0,1-1.17.54.465.465,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.466.466,0,0,0,.1.054.968.968,0,0,1,.54,1.17.464.464,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.468.468,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.466.466,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.465.465,0,0,0,865.543,138.054Z",
    transform: "translate(-702.931 -95.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5297",
    "data-name": "Trazado 5297",
    className: "cls-5",
    d: "M965.543,766.054a.968.968,0,0,1-.54-1.17.463.463,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.467.467,0,0,0-.054.1.968.968,0,0,1-1.17.54.463.463,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.468.468,0,0,0,.1.054.968.968,0,0,1,.54,1.17.463.463,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.461.461,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.464.464,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.467.467,0,0,0,965.543,766.054Z",
    transform: "translate(-712.577 -592.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5298",
    "data-name": "Trazado 5298",
    className: "cls-5",
    d: "M173.542,244.054a.968.968,0,0,1-.54-1.17.466.466,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.465.465,0,0,0-.054.1.968.968,0,0,1-1.17.54.465.465,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.466.466,0,0,0,.1.054.968.968,0,0,1,.54,1.17.465.465,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.466.466,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.466.466,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.466.466,0,0,0,173.542,244.054Z",
    transform: "translate(-170.3 -195.838)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_827",
    "data-name": "Elipse 827",
    className: "cls-7",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(19.347 73.264)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_828",
    "data-name": "Elipse 828",
    className: "cls-7",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(223.327 85.914)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8327",
    "data-name": "Grupo 8327",
    className: "cls-8",
    transform: "translate(108.907 67)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6047",
    "data-name": "Rect\\xE1ngulo 6047",
    className: "cls-9",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6048",
    "data-name": "Rect\\xE1ngulo 6048",
    className: "cls-9",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8328",
    "data-name": "Grupo 8328",
    className: "cls-8",
    transform: "translate(127.806 124.518)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6049",
    "data-name": "Rect\\xE1ngulo 6049",
    className: "cls-9",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6050",
    "data-name": "Rect\\xE1ngulo 6050",
    className: "cls-9",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8329",
    "data-name": "Grupo 8329",
    className: "cls-8",
    transform: "translate(5.116 185.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6051",
    "data-name": "Rect\\xE1ngulo 6051",
    className: "cls-9",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6052",
    "data-name": "Rect\\xE1ngulo 6052",
    className: "cls-9",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8330",
    "data-name": "Grupo 8330",
    className: "cls-8",
    transform: "translate(195.113 108.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6053",
    "data-name": "Rect\\xE1ngulo 6053",
    className: "cls-9",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6054",
    "data-name": "Rect\\xE1ngulo 6054",
    className: "cls-9",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5299",
    "data-name": "Trazado 5299",
    className: "cls-7",
    d: "M793.629,117.481l1.7,1.556,2.406-3.538.849.708-3.255,4.245-2.406-2.689Z",
    transform: "translate(-583.951 -85.061)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTruck);
export default __webpack_public_path__ + "static/media/error-truck.11663cb867ea73d46a3214609d195b70.svg";
export { ForwardRef as ReactComponent };